<template>
  <div>
    <v-btn
      color="success"
      small
      :disabled="selectedIds.length === 0"
      class="mt-2 white--text"
      @click="clientCompletion(selectedIds)"
    >
      一括校了
    </v-btn>
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th v-if="orders.length">
              <input
                type="checkbox"
                @click="selectAllIds"
              />
            </th>
            <th class="text-center">id</th>
            <th class="text-left">記事種別</th>
            <th class="text-left">タイトル</th>
            <th class="text-left">校了期限</th>
            <th class="text-left">単価</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders" :key="order.id">
            <td>
              <input
                v-model="selectedIds"
                type="checkbox"
                :value="order.id"
              />
            </td>
            <td class="text-center">{{ order.id }}</td>
            <td>{{ order.postClassification }}</td>
            <td>{{ order.title }}</td>
            <td>{{ order.clientCompletionDeadline | momentDate }}</td>
            <td>{{ order.salesPrice | jpyPriceNotation }}</td>
            <td class="text-center">
              <v-btn
                color="success"
                class="mt-2"
                small
                @click="clientCompletion([order.id])"
              >
                校了
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import moment from 'moment'
import format_utils from '@/mixins/format_utils'

export default {
  filters: {
    momentDate: function (val) {
      if (val) {
        return moment(val).format('YYYY/M/D')
      }
    }
  },
  mixins: [format_utils],
  props: {
    orders: {
      type: Array,
      required: true
    }
  },
  data: () => {
    return {
      selectedIds: [],
      isAllSelected: false
    }
  },
  methods: {
    selectAllIds () {
      if (!this.isAllSelected) {
        this.selectedIds = []
        this.selectedIds = this.orders.map(order => order.id)
        this.isAllSelected = true
      } else {
        this.selectedIds = []
        this.isAllSelected = false
      }
    },
    clientCompletion (orderIds) {
      if (
        confirm(
          `${orderIds.length}件の校了を行います。本当によろしいですか？`
        )
      ) {
        this.$emit('client-completion', orderIds)
        this.selectedIds = []
        this.isAllSelected = false
      }
    }
  }
}
</script>

<style scoped lang="sass">
th, td
  vertical-align: middle
</style>
